/** Calendar-local contrast policy approved for DNKADM-0181, tokenized for DNKADM-0271. */
import { buildCalendarMaps } from '@/theme/maps/calendar';

/** The cancelled-block label ink for a mode (light default — the DNKADM-0181 value). */
export function cancelledBlockText(mode: 'light' | 'dark' = 'light'): string {
  return buildCalendarMaps(mode).cancelledBlockText;
}

/** The cancelled-row label ink for a mode (light default — the DNKADM-0181 value). */
export function cancelledListText(mode: 'light' | 'dark' = 'light'): string {
  return buildCalendarMaps(mode).cancelledListText;
}

export const CANCELLED_DECORATIVE_OPACITY = 0.55;

// The heatmap foreground/background policy functions died with the Week
// Heatmap (DNKADM-0300 B9 — its signal folded into the schedule); the
// `heatmap*` fields on CalendarMaps remain as documented map data.

/**
 * Apply opacity to a decorative color without affecting sibling semantic content.
 * Accepts either a `#rrggbb` hex (the light palette) or an `rgb(a)(...)` triple (the
 * dark service palette's translucent tints, DNKADM-0271) — either way the ORIGINAL
 * alpha is discarded and replaced with {@link CANCELLED_DECORATIVE_OPACITY}, matching
 * the pre-0271 hex-only behavior.
 */
export function dimDecorativeColor(color: string): string {
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${CANCELLED_DECORATIVE_OPACITY})`;
  }
  const m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/.exec(color);
  const [r, g, b] = m ? [m[1], m[2], m[3]] : ['0', '0', '0'];
  return `rgba(${r}, ${g}, ${b}, ${CANCELLED_DECORATIVE_OPACITY})`;
}
